import { createIcon } from "@chakra-ui/icons";

// Created from layers.svg

export const DrawIcon = createIcon({
  displayName: "Draw",
  viewBox: "0 0 22 22",
  path: (
    <g>
      <path
        d="M15.75 1.57843C16.0126 1.31578 16.3244 1.10744 16.6676 0.965301C17.0108 0.823159 17.3786 0.75 17.75 0.75C18.1214 0.75 18.4892 0.823159 18.8324 0.965301C19.1756 1.10744 19.4874 1.31578 19.75 1.57843C20.0126 1.84107 20.221 2.15287 20.3631 2.49603C20.5053 2.8392 20.5784 3.20699 20.5784 3.57843C20.5784 3.94986 20.5053 4.31766 20.3631 4.66082C20.221 5.00398 20.0126 5.31578 19.75 5.57843L6.25 19.0784L0.75 20.5784L2.25 15.0784L15.75 1.57843Z"
        stroke="currentColor"
        fill="transparent"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
});
